var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 29.9C13 29.9 24.2696 19.8826 24.2696 12.3695C24.2696 6.14553 19.224 1.09998 13 1.09998C6.77602 1.09998 1.73047 6.14553 1.73047 12.3695C1.73047 19.8826 13 29.9 13 29.9Z",
    stroke: "#E6E6E6",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6005 11.9002C16.6005 13.8884 14.9887 15.5002 13.0005 15.5002C11.0123 15.5002 9.40049 13.8884 9.40049 11.9002C9.40049 9.91198 11.0123 8.3002 13.0005 8.3002C14.9887 8.3002 16.6005 9.91198 16.6005 11.9002Z",
    stroke: "#E6E6E6",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.98552be3184846411fb2147b4480b204.svg";
export { ForwardRef as ReactComponent };